var _circle, _circle2, _circle3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmailverificationImage = function SvgEmailverificationImage(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 224,
    viewBox: "0 0 273 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.52,
    cy: 79.52,
    r: 79.52,
    fill: "#FFF2F3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.36,
    cy: 180.88,
    r: 43.12,
    fill: "#FFF2F3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.08,
    cy: 55.4413,
    r: 24.08,
    fill: "#FFF2F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1447_68736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.4 80.8691L79.9998 124.176V132.247H136.317H192.634V124.176L139.234 80.8691C137.532 79.489 135.101 79.489 133.4 80.8691Z",
    fill: "#FF9102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.352 177.003H89.2836C86.7203 177.003 84.6421 174.917 84.6421 172.344V84.097C84.6421 81.5243 86.7201 79.4385 89.2836 79.4385H183.352C185.915 79.4385 187.993 81.5243 187.993 84.097V172.345C187.993 174.917 185.915 177.003 183.352 177.003Z",
    fill: "url(#paint0_linear_1447_68736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.993 169.754V171.567C187.993 174.571 185.565 177.008 182.573 177.008H90.0626C87.0704 177.008 84.6421 174.57 84.6421 171.567V169.754H187.993Z",
    fill: "url(#paint1_linear_1447_68736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.178 94.1934H106.457V97.6098H166.178V94.1934Z",
    fill: "#C2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.178 107.856H106.457V111.273H166.178V107.856Z",
    fill: "#C2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.178 121.835H106.457V125.251H166.178V121.835Z",
    fill: "#C2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.178 135.809H106.457V139.225H166.178V135.809Z",
    fill: "#C2CECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.603 125.557C168.973 125.557 164.731 123.896 161.431 121.137L160.143 121.364L187.992 149.316V118.949C184.503 122.994 179.353 125.557 173.603 125.557Z",
    fill: "url(#paint2_linear_1447_68736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.634 124.279V187.987C192.634 190.558 190.555 192.645 187.992 192.645H84.6413C82.0791 192.645 79.9998 190.558 79.9998 187.987V124.279L136.936 169.353L192.634 124.279Z",
    fill: "url(#paint3_linear_1447_68736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.009 190.314L139.85 148.105C138.149 146.729 135.723 146.729 134.023 148.105L81.0688 190.958C81.9205 191.987 83.2046 192.644 84.642 192.644H187.993C189.71 192.644 191.206 191.705 192.009 190.314Z",
    fill: "url(#paint4_linear_1447_68736)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.001 126.111C183.273 126.111 191.601 117.753 191.601 107.443C191.601 97.1325 183.273 88.7744 173.001 88.7744C162.728 88.7744 154.4 97.1325 154.4 107.443C154.4 117.753 162.728 126.111 173.001 126.111Z",
    fill: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.9 103.019C169.9 102.577 170.118 102.229 170.554 101.974L173.794 99.4232C174.022 99.2363 174.303 99.1426 174.635 99.1426C175.009 99.1426 175.347 99.2235 175.648 99.3849C175.949 99.5465 176.1 99.7634 176.1 100.035V116.918C176.1 117.19 175.933 117.407 175.601 117.569C175.269 117.73 174.885 117.811 174.449 117.811C173.991 117.811 173.602 117.73 173.28 117.569C172.958 117.407 172.797 117.19 172.797 116.918V102.738L171.707 103.861C171.499 104.031 171.271 104.116 171.021 104.116C170.71 104.116 170.445 104.001 170.227 103.772C170.009 103.542 169.9 103.291 169.9 103.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6066 173.392V84.554C85.6066 81.964 87.72 79.8642 90.3266 79.8642H185.986C186.912 79.8642 187.774 80.1333 188.503 80.5914C187.666 79.2775 186.195 78.4023 184.514 78.4023H88.855C86.2484 78.4023 84.135 80.5022 84.135 83.0921V171.93C84.135 173.6 85.0158 175.062 86.3384 175.893C85.8774 175.168 85.6066 174.313 85.6066 173.392Z",
    fill: "url(#paint5_linear_1447_68736)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1447_68736",
    x: 64.9998,
    y: 63.4023,
    width: 142.634,
    height: 144.243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1447_68736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1447_68736",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1447_68736",
    x1: 95.0819,
    y1: 86.8289,
    x2: 203.714,
    y2: 195.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EFEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1447_68736",
    x1: 188.896,
    y1: 168.922,
    x2: 79.696,
    y2: 177.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1447_68736",
    x1: 189.117,
    y1: 135.256,
    x2: 163.643,
    y2: 109.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1447_68736",
    x1: 136.319,
    y1: 146.02,
    x2: 136.319,
    y2: 187.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#FFBB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#FFA801"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1447_68736",
    x1: 136.834,
    y1: 192.488,
    x2: 136.834,
    y2: 146.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDB41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1447_68736",
    x1: 110.006,
    y1: 101,
    x2: 29.9714,
    y2: 20.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmailverificationImage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/emailverification-image.792215076d8c58050f9782c27984752e.svg";